import { Observable } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { Picklist } from "src/app/shared/types/blog-types";
import { toggleAnimation } from "src/app/shared/animations";
import { PicklistType } from "src/app/shared/enums/picklist-types";
import { Component, forwardRef, Input, OnInit } from "@angular/core";
import { PicklistService } from "src/app/shared/services/picklist.service";
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: "app-picklist-select",
  templateUrl: "./picklist-select.component.html",
  animations: [toggleAnimation],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PicklistSelectComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class PicklistSelectComponent implements ControlValueAccessor, OnInit {
  public options$!: Observable<Picklist[]>;
  public input = null;

  @Input() minTermLength = 2;
  @Input() type!: PicklistType;
  @Input() labelForId!: string;
  @Input() selectControl!: FormGroup;
  @Input() formControlName!: string;
  @Input() searchable = true;

  formModalControl!: FormGroup;

  newPickListItem: Picklist;

  constructor(public picklistService: PicklistService, public translate: TranslateService, public fb: FormBuilder) {
    this.newPickListItem = {} as Picklist;
  }

  fetchOptions = () => {
    this.options$ = this.picklistService.getPicklistOptions(this.type);

    const optionsSubscription = this.options$.subscribe((options) => {
      optionsSubscription.unsubscribe();
      if (options.length > 0 && !this.selectControl.get(this.formControlName)?.value) {
        this.selectControl.patchValue({
          [this.formControlName]: options[0].id,
        });
        this.onChange(options[0].id);
      }
    });
  };

  ngOnInit(): void {
    this.fetchOptions();

    if (this.selectControl.valid && this.formControlName) {
      this.selectControl.get(this.formControlName)?.valueChanges.subscribe(() => {});
    }
  }

  addTagFn = ($event: any) => {
    this.createNew($event);
  };

  createNew($event: any) {
    if (!this.newPickListItem) {
      return;
    }
    this.newPickListItem.title = $event;
    this.newPickListItem.delimeter = this.type;
    this.newPickListItem.value = "";
    const fetchSubscriptions = this.picklistService.postPickListOptions(this.newPickListItem).subscribe({
      next: () => {
        fetchSubscriptions.unsubscribe();
        this.fetchOptions();
      },
      error: (error) => {
        fetchSubscriptions.unsubscribe();
        console.error("Error occurred while posting picklist options:", error);
      },
    });
  }

  // ControlValueAccessor implementation
  writeValue(value: any): void {
    if (value) {
      this.selectControl.patchValue({ [this.formControlName]: value });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.selectControl.disable() : this.selectControl.enable();
  }

  onChange(_: any) {}
  onTouched() {}
}
